"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.xslNs = exports.xmlnsNs = exports.xdNs = exports.nsXsl = exports.nsXsi = exports.nsXsf3 = exports.nsXsf2 = exports.nsXsf = exports.nsXsd = exports.nsXmlns = exports.nsXdXDocument = exports.nsXd = exports.nsWsdl = exports.nsSoap12 = exports.nsSoap = exports.nsQ = exports.nsPc = exports.nsMsxsl = exports.nsMa = exports.nsIct2 = exports.nsIct = exports.nsDms = exports.nsDfs = exports.nsD = exports.nsCme = exports.nsAdoD = exports.namespaces = exports.msxslNs = void 0;
var nsAdoD = exports.nsAdoD = 'http://schemas.microsoft.com/office/infopath/2003/ado/dataFields';
var nsCme = exports.nsCme = 'http://schemas.microsoft.com/office/infopath/2009/WSSList/cmeDataFields';
var nsD = exports.nsD = 'http://schemas.microsoft.com/office/infopath/2009/WSSList/dataFields';
var nsQ = exports.nsQ = 'http://schemas.microsoft.com/office/infopath/2009/WSSList/queryFields';
var nsDfs = exports.nsDfs = 'http://schemas.microsoft.com/office/infopath/2003/dataFormSolution';
var nsDms = exports.nsDms = 'http://schemas.microsoft.com/office/2009/documentManagement/types';
var nsIct = exports.nsIct = 'http://schemas.microsoft.com/office/infopath/2003/ict';
var nsIct2 = exports.nsIct2 = 'ict2';
var nsMa = exports.nsMa = 'http://schemas.microsoft.com/office/2009/metadata/properties/metaAttributes';
var nsMsxsl = exports.nsMsxsl = 'urn:schemas-microsoft-com:xslt';
/**
 * Deprecated. Use nsMsxsl instead.
 */
var msxslNs = exports.msxslNs = nsMsxsl;
var nsPc = exports.nsPc = 'http://schemas.microsoft.com/office/infopath/2007/PartnerControls';
var nsXd = exports.nsXd = 'http://schemas.microsoft.com/office/infopath/2003';

/**
 * Deprecated. Use nsXd instead.
 */
var xdNs = exports.xdNs = nsXd;
var nsXdXDocument = exports.nsXdXDocument = 'http://schemas.microsoft.com/office/infopath/2003/xslt/xDocument';
var nsXmlns = exports.nsXmlns = 'http://www.w3.org/2000/xmlns/';
/**
 * Deprecated. Use nsXmlns instead.
 */
var xmlnsNs = exports.xmlnsNs = nsXmlns;
var nsXsd = exports.nsXsd = 'http://www.w3.org/2001/XMLSchema';
var nsXsi = exports.nsXsi = 'http://www.w3.org/2001/XMLSchema-instance';
var nsXsf = exports.nsXsf = 'http://schemas.microsoft.com/office/infopath/2003/solutionDefinition';
var nsXsf2 = exports.nsXsf2 = 'http://schemas.microsoft.com/office/infopath/2006/solutionDefinition/extensions';
var nsXsf3 = exports.nsXsf3 = 'http://schemas.microsoft.com/office/infopath/2009/solutionDefinition/extensions';
var nsXsl = exports.nsXsl = 'http://www.w3.org/1999/XSL/Transform';
/**
 * Deprecated. Use nsXsl instead.
 */
var xslNs = exports.xslNs = nsXsl;
var nsWsdl = exports.nsWsdl = 'http://schemas.xmlsoap.org/wsdl/';
var nsSoap = exports.nsSoap = 'http://schemas.xmlsoap.org/wsdl/soap/';
var nsSoap12 = exports.nsSoap12 = 'http://schemas.xmlsoap.org/wsdl/soap12/';
var namespaces = exports.namespaces = {
  adod: nsAdoD,
  cme: nsCme,
  xsl: nsXsl,
  xd: nsXd,
  xsd: nsXsd,
  xsf: nsXsf,
  xsf2: nsXsf2,
  xsf3: nsXsf3,
  xsi: nsXsi,
  ict: nsIct,
  ict2: nsIct2,
  dfs: nsDfs,
  q: nsQ,
  d: nsD,
  dms: nsDms,
  ma: nsMa,
  pc: nsPc,
  msxsl: nsMsxsl,
  xmlns: nsXmlns,
  wsdl: nsWsdl,
  soap: nsSoap,
  soap12: nsSoap12
};